import { AttendancePdf } from "./AttendancePdf";

export default AttendancePdf;
